import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=7af953bd&scoped=true"
import script from "./Goal.vue?vue&type=script&lang=ts"
export * from "./Goal.vue?vue&type=script&lang=ts"
import style0 from "./Goal.vue?vue&type=style&index=0&id=7af953bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af953bd",
  null
  
)

export default component.exports